import React from 'react';

export const CountBadge = ({ n, testId }) => (
  <span data-testid={testId} style={{ marginLeft: 'auto', background: '#e53e3e', color: 'white', minWidth: 20, height: 20, padding: '0 6px', borderRadius: 50,
    fontSize: '0.72rem', fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
    {n > 99 ? '99+' : n}
  </span>
);
